export const MINS = {
  0: "00",
  25: "15",
  50: "30",
  75: "45",
};

export const DEFAULT_MARKS = [
  {
    value: 0,
  },
  {
    value: 25,
  },
  {
    value: 50,
  },
  {
    value: 75,
  },
];

export const DURATION_OPTIONS = [6, 8, 12];

export const DEFAULT_START_TIME = 4;
export const DEFAULT_START_TIME_LABEL = "04:00";

export const MIN_TIME = -1;
export const MAX_TIME = 16;

export const MINUTES_TO_SLIDER_FORMAT = {
  0: 0,
  15: 25,
  30: 50,
  45: 75,
};

export const FINAL_ROUTES_TIME = "16:00";
